var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "874px",
    height: "874px",
    viewBox: "0 0 874 874",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "WoW-Book-Icons",
    transform: "translate(-5527.000000, -8327.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Hert-Pulse",
    transform: "translate(5528.000000, 8328.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#979797",
    fill: "#00D2C9",
    x: 0,
    y: 0,
    width: 872,
    height: 872,
    rx: 68
  }), /*#__PURE__*/React.createElement("g", {
    id: "heart-pulse-Shadow",
    transform: "translate(180.000000, 212.000000)",
    fill: "#616063",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.384027,211.801918 L270.554027,311.301918 C264.545027,323.301918 247.144027,322.921918 241.634027,310.676918 L184.684027,184.301918 L154.634027,256.051918 L56.5340275,256.001918 L232.934027,438.201918 C245.594027,451.271918 266.294027,451.271918 278.964027,438.201918 L455.364027,256.001918 L343.264027,256.007118 L320.384027,211.801918 Z M463.184027,30.8619182 C408.824027,-16.1180818 325.684027,-7.63808181 275.684027,43.9219182 L255.984027,64.2519182 L236.284027,43.9219182 C186.284027,-7.63808181 103.184027,-16.1180818 48.7940275,30.8619182 C-8.64597253,80.5019182 -15.1759725,165.601918 28.1640275,224.001918 L133.164027,224.001918 L169.094027,137.751918 C174.602027,124.871918 192.754027,124.631918 198.634027,137.376918 L256.844027,266.776918 L305.914027,168.776918 C311.798027,157.026918 328.694027,157.026918 334.584027,168.776918 L362.254027,224.026918 L483.754027,224.026918 C527.184027,165.601918 520.584027,80.5019182 463.184027,30.8619182 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "heart-pulse",
    transform: "translate(172.000000, 203.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320.384027,211.801918 L270.554027,311.301918 C264.545027,323.301918 247.144027,322.921918 241.634027,310.676918 L184.684027,184.301918 L154.634027,256.051918 L56.5340275,256.001918 L232.934027,438.201918 C245.594027,451.271918 266.294027,451.271918 278.964027,438.201918 L455.364027,256.001918 L343.264027,256.007118 L320.384027,211.801918 Z M463.184027,30.8619182 C408.824027,-16.1180818 325.684027,-7.63808181 275.684027,43.9219182 L255.984027,64.2519182 L236.284027,43.9219182 C186.284027,-7.63808181 103.184027,-16.1180818 48.7940275,30.8619182 C-8.64597253,80.5019182 -15.1759725,165.601918 28.1640275,224.001918 L133.164027,224.001918 L169.094027,137.751918 C174.602027,124.871918 192.754027,124.631918 198.634027,137.376918 L256.844027,266.776918 L305.914027,168.776918 C311.798027,157.026918 328.694027,157.026918 334.584027,168.776918 L362.254027,224.026918 L483.754027,224.026918 C527.184027,165.601918 520.584027,80.5019182 463.184027,30.8619182 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulse);
export default __webpack_public_path__ + "static/media/Pulse.0a1a0ff895cf5f06ab80f3371e6096a7.svg";
export { ForwardRef as ReactComponent };